import { getLocaleDateFormat } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CodePanneOccurrence } from 'src/app/model/breakdowns/breakdown';
import { CallStat, CodePanne, ContractType } from 'src/app/model/call/call.model';
import { Action, Intervenant, TypeAppel } from 'src/app/model/gestion/gestion';
import { InstallContract } from 'src/app/model/installation/installation.model';
import { InstallMes } from 'src/app/model/installations/installations.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { GestionActionsSavService } from 'src/app/services/http/gestion/gestion-actions-sav.service';
import { GestionIntervenantsSavService } from 'src/app/services/http/gestion/gestion-intervenants-sav.service';
import { GestionTypesAppelsService } from 'src/app/services/http/gestion/gestion-types-appels.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-service-install',
  templateUrl: './service-install.component.html',
  styleUrls: ['./service-install.component.scss']
})
export class ServiceInstallComponent implements OnInit {


  get displayedColumnInstallMes(): string[] {
    const result: string[] = ['numSerie', 'dateMes', 'nom'];
    return result;
  }


  constructor(private service: CallService,
    private builder: FormBuilder,
    private utils: UtilsService,
    private router: Router) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;

  /** Types of contracts */
  typesContrat!: ContractType[];

  /**
   * List of contracts found
   */
   installMes!: InstallMes[];

  /**
   * Search Form installations mise en service
   */
   searchInstallMesForm!: FormGroup;


  ngOnInit(): void {


    /** Load the contracts types available */
    this.service.getContractsTypes().subscribe((contracts) => {
      this.typesContrat = contracts;
    });

    this.searchInstallMesForm = this.builder.group({
      mesDate: ['']
    }
    );

  }


  onSubmitMesInstall() {
    this.isLoading = true;

    // Since issue 55 - get contract dates and type 
    // /installservicelist/?mesDate=2022-03-01
   

    this.service.getInstallServiceList(this.searchInstallMesForm.controls.mesDate.value).subscribe((installs) => {
      this.installMes = installs;
      this.isLoading = false;
    });
  }



  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }

  clickInstall(row : InstallMes){
    this.router.navigate(['installation', row.ID_INSTALLATION]);
  }

}
